import React from 'react';
import { PrinterIcon, ScissorsIcon, HeartHandshakeIcon } from 'lucide-react';
import { steps } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
const visuals = [{
  Icon: PrinterIcon,
  tone: 'bg-gold-wash text-gold-deep'
}, {
  Icon: ScissorsIcon,
  tone: 'bg-coral-wash text-coral-deep'
}, {
  Icon: HeartHandshakeIcon,
  tone: 'bg-leaf-wash text-leaf-deep'
}];
export function HowItWorks() {
  return <section aria-labelledby="how-title" className="bg-paper" data-id="element-162" data-mp="lmmgz6jeokhe">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-163" data-mp="qiv1z0kab7wh">
        <SectionHeading id="how-title" title="Sharing Jesus Can Be This Simple" intro="No design work. No guessing. Three steps from your printer to someone’s hands." data-id="element-164" data-mp="csri2g8vnqa7" />
        <ol className="relative mt-16 grid gap-12 md:grid-cols-3 md:gap-8" data-id="element-165" data-mp="14j5q3vu7m8dy">
          <span className="absolute left-[16.6%] right-[16.6%] top-12 hidden border-t-2 border-dashed border-cream-line md:block" aria-hidden="true" data-id="element-166" data-mp="14h1fyw5pwd58" />
          {steps.map((step, i) => {
          const {
            Icon,
            tone
          } = visuals[i];
          return <li key={step.title} className="relative flex flex-col items-center text-center" data-id="element-167" data-mp="2mnmeeqv04llv" data-mpi={i}>
                <span className={`relative flex h-24 w-24 items-center justify-center rounded-full ring-8 ring-paper ${tone}`} data-id="element-168" data-mp="31ciw7fmv1czo">
                  <Icon className="h-10 w-10" strokeWidth={1.75} aria-hidden="true" data-id="element-169" data-mp="2wjfzwzqp7pfs" />
                  <span className="absolute -right-1 -top-1 flex h-8 w-8 items-center justify-center rounded-full bg-navy text-sm font-extrabold text-white" data-id="element-170" data-mp="3aaksxizk9jh5">
                    {i + 1}
                  </span>
                </span>
                <h3 className="mt-6 text-2xl font-extrabold uppercase tracking-[0.12em] text-navy" data-id="element-171" data-mp="3k7z7te5u607c">{step.title}</h3>
                <p className="mt-2 max-w-[18rem] text-base leading-relaxed text-ink-soft" data-id="element-172" data-mp="1pw2dndg0eg8l">{step.text}</p>
              </li>;
        })}
        </ol>
        <div className="mt-14 flex justify-center" data-id="element-173" data-mp="1kz26ez7fb7fw">
          <CtaButton data-id="element-174" data-mp="3l00d0o4ts489">Get Instant Access</CtaButton>
        </div>
      </div>
    </section>;
}